import { render, staticRenderFns } from "./CompanyShortlistsSelector.vue?vue&type=template&id=644afb2e&"
import script from "./CompanyShortlistsSelector.vue?vue&type=script&lang=js&"
export * from "./CompanyShortlistsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports